






















import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemCheckBox extends Mixins(TcwFormItemCommon) {
  @Prop({ default: '' })
  private value!: string
  @Prop({ default: '1' })
  private trueValue!: string
  @Prop({ default: '0' })
  private falseValue!: string

  @Emit()
  private input(_value: string): void {
    /** */
  }
}
